export default __webpack_public_path__ + "static/ctaModule_table_desktop-1e3d37ba4fa8152fd1227a7952a1a246.webp";